import { Component, Input } from '@angular/core';
import { ModalController, LoadingController, AlertController } from '@ionic/angular';

import { BasePage } from 'src/app/pages/base.page';
import { AuthService } from 'src/app/shared/services/auth.service';
import { JobsService } from 'src/app/shared/services/jobs.service';
import { FlexJobsService } from '../../services/flex-jobs.service';

@Component({
  selector: 'app-cancel-job',
  templateUrl: './cancel-job.component.html',
  styleUrls: ['./cancel-job.component.scss'],
})
export class CancelJobComponent extends BasePage {
  @Input() jobId;

  constructor(
    public modalCtrl: ModalController,
    public auth: AuthService,
    protected flexJobsService: FlexJobsService,
    protected loadingCtrl: LoadingController,
    public alertCtrl: AlertController,
    private jobsService: JobsService,
  ) {
    super('CancelJobComponent');
  }

  /**
   * Cancel last minute job
   *
   */
  async cancelJob() {
    this.showLoading();
    try {
      const res = await this.flexJobsService.flexJobClientAction({
        id: this.jobId,
        action: 'cancel',
      });
      if (res) {
        // refresh the job list
        this.jobsService.refreshJobList();
        this.modalCtrl.dismiss(true);
      }
    } catch (error) {
      this.modalCtrl.dismiss(true);
      this.showAlert('Error', 'Unable to perform action. Please try again later');
    } finally {
      this.hideLoading();
    }
  }
}
